import { client } from 'app/http';

export const verifyOTPCode = async (phone: string, code: string) => {
  const response = await client.post(`/auth/verify-otp-code`, { phone, code });
  return response.data;
};
